import React from 'react';

const PinIcon = ({ width = 24, height = 24, color = 'currentColor', ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    width={width}
    height={height}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path d="M14.4 3v1.2h1.2v4.8l2.4 2.4v2.4h-5.4v5.4l-.6 1.8-.6-1.8v-5.4H6v-2.4l2.4-2.4V4.2h1.2V3h4.8z" />
  </svg>
);

export default PinIcon;
